import {objectFromEntries, entry} from '@benchling/js-utils';
import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {ExpandedItemTableQuery} from 'nav/expanded/__generated/ExpandedItemTableQuery';
import {QS_AMOUNT} from 'notebook/integrations/registry/MixtureGroupConstants';
import {getBioentityChipDefaultSecondaryText} from 'ui-library/chips/BioentityChip';
import {ChipSize} from 'ui-library/chips/Chip';
import {CHIP_DISPLAY_LIMIT_TABLE_ROW} from 'ui-library/chips/ChipConstants';
import ChipList from 'ui-library/chips/ChipList';

import {BioentityChipSummaryGraphQL} from '../../../graphql-fragments/registry/registry-items/__generated/BioentityChipSummaryGraphQL';

type ExpandedItemTableMixtureGraphQL = ExtractByTypename<
  ExpandedItemTableQuery['bioentities'][number],
  'MixtureNode'
>;

type ExpandedItemTableIngredientGraphQL = ExpandedItemTableMixtureGraphQL['ingredients'][number];

interface Props {
  mixture?: ExpandedItemTableMixtureGraphQL;
}

function getIngredientAmountText(ingredient?: {amount: string | null; units: string}): string | null {
  if (ingredient?.amount === QS_AMOUNT) {
    return ingredient.amount;
  } else if (ingredient?.amount && ingredient?.units) {
    return `${ingredient.amount}${ingredient.units}`;
  }
  return null;
}

export default function MixtureIngredientsList({mixture}: Props): JSX.Element | null {
  if (!mixture) {
    return null;
  }

  const ingredientsByComponentBioentityId = objectFromEntries(
    mixture.ingredients.map((ingredient) =>
      entry(ingredient.componentBioentity.id, {amount: ingredient.amount, units: ingredient.units})
    )
  );

  return (
    <ChipList
      itemIds={mixture.ingredients.map(
        (ingredient: ExpandedItemTableIngredientGraphQL) => ingredient.componentBioentity.id
      )}
      maxChips={CHIP_DISPLAY_LIMIT_TABLE_ROW}
      chipSize={ChipSize.SMALL}
      getSecondaryText={(b: BioentityChipSummaryGraphQL) =>
        [
          getBioentityChipDefaultSecondaryText(b),
          getIngredientAmountText(ingredientsByComponentBioentityId[b.id]),
        ]
          .filter((text) => text != null)
          .join(' | ')
      }
    />
  );
}
